interface ControlsProps {
  follow: boolean;
  onFollowChange: (follow: boolean) => void;
  onCenterClick: () => void;
}

export function Controls({ onCenterClick }: ControlsProps) {
  return (
    <div className="absolute top-20 right-4 z-10 flex flex-col gap-2">
      <button
        onClick={onCenterClick}
        className="p-3 bg-white/90 hover:bg-white text-neutral-900 rounded-lg shadow-lg font-medium transition-colors text-lg"
        aria-label="Recentrer sur la position"
      >
        🎯
      </button>
    </div>
  );
}